var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "main" } },
        [
          _c("div", { attrs: { id: "menustores" } }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { attrs: { id: "products" } }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm.categories.length == 0
                        ? _c(
                            "div",
                            { staticClass: "col-md-12 loading-coupons" },
                            [
                              _c("h5", [
                                _vm._v("Aguarde, carregando categorias...")
                              ])
                            ]
                          )
                        : _vm._l(_vm.categories, function(category, c) {
                            return _c(
                              "div",
                              { key: c, staticClass: "col-md-4 category" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { target: "_blank" },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectCategory(category.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(category.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-4" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm.products.length == 0
                        ? _c(
                            "div",
                            { staticClass: "col-md-12 loading-coupons" },
                            [_c("h5", [_vm._v("Aguarde, carregando...")])]
                          )
                        : _vm._l(_vm.products, function(product, c) {
                            return _c(
                              "div",
                              { key: c, staticClass: "col-md-3 product" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: product.link
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "image" }, [
                                      _c("img", {
                                        attrs: { src: product.thumbnail }
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "price" }, [
                                        _c("b", [
                                          _vm._v(
                                            "Por " +
                                              _vm._s(
                                                _vm.formatCurrency(
                                                  product.price
                                                )
                                              )
                                          )
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "info" }, [
                                      _c("h4", [_vm._v(_vm._s(product.name))])
                                    ])
                                  ]
                                )
                              ]
                            )
                          })
                    ],
                    2
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.showScrollButton
              ? _c("div", { attrs: { id: "scrollToTop" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.scrollToTop()
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: ["fas", "chevron-circle-up"],
                          size: "lg"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "vitrine" } }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("h1", [_vm._v("Confira nossos Descontos do Bem")]),
            _vm._v(" "),
            _c("h4", [
              _vm._v("Ajude nossos projetos com descontos imperdíveis!")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-section" }, [
      _c("h3", [_vm._v("Categorias em Destaque")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Confira aqui as categorias que mais venderam essa semana!")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-section" }, [
      _c("h3", [_vm._v("Produtos em Destaque")]),
      _vm._v(" "),
      _c("span", [_vm._v("Confira aqui as melhores ofertas da semana!")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e6d974b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e6d974b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/descontosdobem/MainProdutos.vue
// module id = null
// module chunks = 